export { default as DisclaimerMain } from './View'
